import React, { useState, useEffect } from 'react'

// Material-UI
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Container from '@mui/material/Container'
import WebsiteInput from './WebsiteInput'
import Grid from '@mui/material/Grid'
import { FaRegCheckCircle } from 'react-icons/fa'
import './ContactUs.scss'
import { IARDialog } from '../../../Shared/Dialog/IARDialog'
import { useCMSContext } from './../../CMSContext'
import { useErrorSnackBarContext } from '../../../Shared/ErrorSnackBar/ErrorSnackBarContext'
import Interceptor from '../../../../Services/serviceBase.interceptor'
import serviceBase from '../../../../Services/serviceBase'
import PhoneInput from '../../../Shared/PhoneInput/PhoneInput'
import { useMenuSectionContext } from './../../MenuSection/MenuSectionContext'
import { timeout } from '../../../../Constants/timeoutTypes'
import ContactActions from './ContactActions'
import CustomDropdown from '../../../Shared/Dropdown/dropdown'

function ContactUs({ fireDepartment }) {
  const { errorSnackBarActions } = useErrorSnackBarContext()
  Interceptor.interceptor(errorSnackBarActions)
  const cmsContext = useCMSContext()
  const [dialog, setDialog] = useState({ open: false })
  const { actions } = useCMSContext()
  const [dataPosted, setDataPosted] = useState({ posted: false, message: '' })
  const menuSectionContext = useMenuSectionContext()
  const { setLastCustomSectionId } = menuSectionContext.actions
  const { isReadOnlyMember } = cmsContext.state
  const [departmentInfoEntity, setDepartmentInfoEntity] = useState({
    phoneNumber: '',
    faxNumber: '',
    emailAddress: '',
    physicalStreetAddress: '',
    mailingStreetAddress: '',
    website: '',
    county: '',
    state: '',
    country: '',
    countryId: '',
    zipCode: '',
    city: ''
  })
  const [countries, setCountries] = useState([])

  const [departmentInfoEntityErrors, setDepartmentInfoEntityErrors] = useState({})
  const [disabledButton, setDisabledButton] = useState(false)

  useEffect(() => {
    setLastCustomSectionId('')
    if (fireDepartment) {
      setDepartmentInfoEntity(fireDepartment)

      if (isReadOnlyMember) {
        setDisabledButton(true)
      }
    }
  }, [fireDepartment])

  useEffect(() => {
    fetchCountries()
  }, [])

  const handleChange = (evt) => {
    const value = evt.target.value
    setDepartmentInfoEntity({
      ...departmentInfoEntity,
      [evt.target.name]: value
    })
  }

  const sendDepartmentInfo = () => {
    setDataPosted({ ...dataPosted, posted: false })
    let errors = {}

    var readyToSave = true

    if (!departmentInfoEntity.phoneNumber) {
      errors.errorPhone = 'This field is required!'
      readyToSave = false
    }

    if (!departmentInfoEntity.faxNumber) {
      errors.errorFax = 'This field is required!'
      readyToSave = false
    }

    if (!departmentInfoEntity.physicalStreetAddress) {
      errors.errorStreetAddress = 'This field is required!'
      readyToSave = false
    }

    if (!departmentInfoEntity.mailingStreetAddress) {
      errors.errorMailingStreet = 'This field is required!'
      readyToSave = false
    }

    if (!departmentInfoEntity.county) {
      errors.errorCounty = 'This field is required!'
      readyToSave = false
    }

    if (!departmentInfoEntity.state) {
      errors.errorState = 'This field is required!'
      readyToSave = false
    }

    if (!departmentInfoEntity.countryId) {
      errors.errorCountry = 'This field is required!'
      readyToSave = false
    }

    if (!departmentInfoEntity.emailAddress) {
      errors.errorEmail = 'This field is required!'
      readyToSave = false
    }

    if (!departmentInfoEntity.city) {
      errors.errorCity = 'This field is required!'
      readyToSave = false
    }

    if (!departmentInfoEntity.zipCode) {
      errors.errorZipCode = 'This field is required!'
      readyToSave = false
    }

    if (
      departmentInfoEntity.facebook &&
      departmentInfoEntity.facebook.indexOf('https://www.facebook.com/') === -1 &&
      departmentInfoEntity.facebook.indexOf('http://www.facebook.com/') === -1
    ) {
      errorSnackBarActions.setOpen(
        true,
        'facebook field must be https://www.facebook.com/[your user name]'
      )
      readyToSave = false
    }

    if (
      departmentInfoEntity.twitter &&
      departmentInfoEntity.twitter.indexOf('https://twitter.com/') === -1 &&
      departmentInfoEntity.twitter.indexOf('http://twitter.com/') === -1
    ) {
      errorSnackBarActions.setOpen(
        true,
        'twitter field must be https://twitter.com/[your user name]'
      )
      readyToSave = false
    }

    if (
      departmentInfoEntity.instagram &&
      departmentInfoEntity.instagram.indexOf('https://www.instagram.com/') === -1 &&
      departmentInfoEntity.instagram.indexOf('http://www.instagram.com/') === -1
    ) {
      errorSnackBarActions.setOpen(
        true,
        'instagram field must be https://www.instagram.com/[your user name]'
      )
      readyToSave = false
    }

    if (
      departmentInfoEntity.linkedin &&
      departmentInfoEntity.linkedin.indexOf('https://www.linkedin.com/company/') === -1 &&
      departmentInfoEntity.linkedin.indexOf('http://www.linkedin.com/company/') === -1
    ) {
      errorSnackBarActions.setOpen(
        true,
        'linkedin field must be https://www.linkedin.com/company/[your user name]'
      )
      readyToSave = false
    }

    setDepartmentInfoEntityErrors(errors)
    setTimeout(() => {
      setDepartmentInfoEntityErrors({})
    }, timeout.fiveSeconds)

    if (readyToSave) {
      let url = `${window._env_.COMMUNITY_API_URL}/fire-departments/contact-us`

      let countryName = countries.find(
        (x) => x.value.toString() === departmentInfoEntity.countryId.toString()
      )
      const data = {
        identifier: fireDepartment.identifier,
        fireDepartmentName: fireDepartment.fireDepartmentName,
        fireDepartmentId: fireDepartment.fireDepartmentId,
        logo: fireDepartment.logo,
        phrase: fireDepartment.phrase,
        latitude: fireDepartment.latitude,
        longitude: fireDepartment.longitude,
        isCommunityAppEnabled: fireDepartment.isCommunityAppEnabled,
        phoneNumber: departmentInfoEntity.phoneNumber,
        faxNumber: departmentInfoEntity.faxNumber,
        emailAddress: departmentInfoEntity.emailAddress,
        physicalStreetAddress: departmentInfoEntity.physicalStreetAddress,
        mailingStreetAddress: departmentInfoEntity.mailingStreetAddress,
        website: departmentInfoEntity.website,
        county: departmentInfoEntity.county,
        state: departmentInfoEntity.state,
        country: countryName.text,
        countryId: parseInt(departmentInfoEntity.countryId),
        zipCode: departmentInfoEntity.zipCode ? departmentInfoEntity.zipCode : '',
        city: departmentInfoEntity.city ? departmentInfoEntity.city : '',
        facebook: departmentInfoEntity.facebook || '',
        twitter: departmentInfoEntity.twitter || '',
        linkedin: departmentInfoEntity.linkedin || '',
        instagram: departmentInfoEntity.instagram || '',
        QRcodeURL: fireDepartment.QRcodeURL
      }

      serviceBase.post(url, data).then(
        (response) => {
          setDataPosted({ posted: true, message: 'Saved' })
          setDepartmentInfoEntity(response.data)
          actions.setFireDepartment(response.data)
          console.log('POST DepartmentInfo: ', response)
        },
        (err) => {
          errorSnackBarActions.setOpen(true)
          setDataPosted({ posted: false, message: 'Error while saving changes' })
          console.log(err)
        }
      )
    }
  }

  const renderSavedMessage = () => {
    if (dataPosted.posted) {
      return (
        <div className="save-message">
          <FaRegCheckCircle className="check-circle" />
          <span className="save-message-text">{dataPosted.message}</span>
        </div>
      )
    }
  }

  const discardChanges = () => {
    setDialog({ open: false })
    if (fireDepartment) {
      console.log('originalFireDepartment', fireDepartment)
      setDepartmentInfoEntity(fireDepartment)
    }
  }

  const openConfirmationDialog = () => {
    setDialog({ open: true })
  }

  const cancelDialog = () => {
    setDialog({ open: false })
  }

  async function fetchCountries() {
    let response = await ContactActions.getCountries()
    const countriesMapped = response.map((x) => {
      return { text: x.name, value: x.countryId }
    })
    setCountries(countriesMapped)
  }

  let saveBtnTextColor = disabledButton ? 'gray' : '#FFF'
  return (
    <div className="App contact-us">
      <div className="page-header" id="contactTitle">
        Menu Section - Contact Us
      </div>
      <IARDialog
        open={dialog.open}
        title="Confirm"
        content="Do you want to discard your changes?"
        onOk={discardChanges}
        onCancel={cancelDialog}
      />

      <Container maxWidth="lg">
        <Grid container spacing={2}>
          <Grid size={12}></Grid>
          <Grid size={12}>
            <div className="page-description">
              Enter all of your organization’s contact information here so that it can be easily
              accessible by your community members. The information here is also the information
              that will be used when community members are searching for your organization to add it
              to their MyLS app, so please verify that everything here is correct.
              <br />
              <br />
              <b>
                Please do not enter any abbreviations on this page (e.g Use “Georgia” and not “GA”).
              </b>
            </div>
          </Grid>

          <Grid size={12}>
            <form
              className="page-content"
              onSubmit={(e) => {
                e.preventDefault()
              }}
              noValidate
              autoComplete="off"
            >
              <Grid container>
                <Grid container size={12}>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <PhoneInput
                      setEntity={setDepartmentInfoEntity}
                      phone={departmentInfoEntity.phoneNumber}
                      label="Phone Number"
                      fieldName="phoneNumber"
                      error={departmentInfoEntityErrors.errorPhone}
                    />
                  </Grid>

                  <Grid size={{ xs: 12, md: 6 }}>
                    <PhoneInput
                      setEntity={setDepartmentInfoEntity}
                      phone={departmentInfoEntity.faxNumber}
                      label="Fax Number"
                      fieldName="faxNumber"
                      error={departmentInfoEntityErrors.errorFax}
                    />
                  </Grid>
                </Grid>
                <Grid container size={12}>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <div className="container-field">
                      <label htmlFor="physicalStreetAddress">Street Address</label>
                      <br />
                      <label htmlFor="error" className="error-text">
                        {departmentInfoEntityErrors.errorStreetAddress}
                      </label>
                      <TextField
                        id="physicalStreetAddress"
                        name="physicalStreetAddress"
                        multiline
                        rows={2}
                        variant="outlined"
                        className="form-control"
                        value={departmentInfoEntity.physicalStreetAddress || ''}
                        onChange={handleChange}
                      />
                    </div>
                  </Grid>

                  <Grid size={{ xs: 12, md: 6 }}>
                    <div className="container-field">
                      <label htmlFor="mailingStreetAddress">Mailing Address</label> <br />
                      <label htmlFor="error" className="error-text">
                        {departmentInfoEntityErrors.errorMailingStreet}
                      </label>
                      <TextField
                        id="mailingStreetAddress"
                        name="mailingStreetAddress"
                        multiline
                        rows={2}
                        variant="outlined"
                        className="form-control"
                        value={departmentInfoEntity.mailingStreetAddress || ''}
                        onChange={handleChange}
                      />
                    </div>
                  </Grid>
                </Grid>

                <Grid container size={12}>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <div className="container-field">
                      <label htmlFor="zipCode">Zip Code</label>
                      <br />
                      <label htmlFor="error" className="error-text">
                        {departmentInfoEntityErrors.errorZipCode}
                      </label>
                      <TextField
                        id="zipCode"
                        name="zipCode"
                        multiline
                        rows={2}
                        variant="outlined"
                        className="form-control"
                        value={departmentInfoEntity.zipCode || ''}
                        onChange={handleChange}
                      />
                    </div>
                  </Grid>

                  <Grid size={{ xs: 12, md: 6 }}>
                    <div className="container-field">
                      <label htmlFor="city">City</label> <br />
                      <label htmlFor="error" className="error-text">
                        {departmentInfoEntityErrors.errorCity}
                      </label>
                      <TextField
                        id="city"
                        name="city"
                        multiline
                        rows={2}
                        variant="outlined"
                        className="form-control"
                        value={departmentInfoEntity.city || ''}
                        onChange={handleChange}
                      />
                    </div>
                  </Grid>
                </Grid>

                <Grid container size={12}>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <div className="container-field">
                      <label htmlFor="county">County</label>
                      <br />
                      <label htmlFor="error" className="error-text">
                        {departmentInfoEntityErrors.errorCounty}
                      </label>
                      <TextField
                        id="county"
                        name="county"
                        multiline
                        rows={2}
                        variant="outlined"
                        className="form-control"
                        value={departmentInfoEntity.county || ''}
                        onChange={handleChange}
                      />
                    </div>
                  </Grid>

                  <Grid size={{ xs: 12, md: 6 }}>
                    <div className="container-field">
                      <label htmlFor="state">State/Province</label> <br />
                      <label htmlFor="error" className="error-text">
                        {departmentInfoEntityErrors.errorState}
                      </label>
                      <TextField
                        id="state"
                        name="state"
                        multiline
                        rows={2}
                        variant="outlined"
                        className="form-control"
                        value={departmentInfoEntity.state || ''}
                        onChange={handleChange}
                      />
                    </div>
                  </Grid>
                </Grid>

                <Grid container size={12}>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <div className="container-field">
                      <label htmlFor="country">Country</label>
                      <br />
                      <label htmlFor="error" className="error-text">
                        {departmentInfoEntityErrors.errorCountry}
                      </label>
                      <div>
                        {departmentInfoEntity.countryId ? (
                          <CustomDropdown
                            name="countryId"
                            value={departmentInfoEntity.countryId}
                            list={countries}
                            onChange={handleChange}
                          />
                        ) : (
                          <CustomDropdown
                            name="countryId"
                            value={0}
                            list={countries}
                            onChange={handleChange}
                          />
                        )}
                      </div>
                    </div>
                  </Grid>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <div className="container-field">
                      <label htmlFor="emailAddress">Email Address</label>
                      <br />
                      <label htmlFor="error" className="error-text">
                        {departmentInfoEntityErrors.errorEmail}
                      </label>
                      <TextField
                        id="emailAddress"
                        name="emailAddress"
                        multiline
                        rows={2}
                        variant="outlined"
                        className="form-control"
                        value={departmentInfoEntity.emailAddress || ''}
                        onChange={handleChange}
                      />
                    </div>
                  </Grid>
                </Grid>
                <Grid container size={12}>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <WebsiteInput
                      setDepartmentInfoEntity={setDepartmentInfoEntity}
                      webURL={departmentInfoEntity.website}
                      attribute="website"
                    />
                  </Grid>

                  <Grid size={{ xs: 12, md: 6 }}>
                    <WebsiteInput
                      setDepartmentInfoEntity={setDepartmentInfoEntity}
                      webURL={departmentInfoEntity.facebook}
                      title="Facebook"
                      attribute="facebook"
                    />
                  </Grid>

                  <Grid size={{ xs: 12, md: 6 }}>
                    <WebsiteInput
                      setDepartmentInfoEntity={setDepartmentInfoEntity}
                      webURL={departmentInfoEntity.twitter}
                      title="Twitter"
                      attribute="twitter"
                    />
                  </Grid>

                  <Grid size={{ xs: 12, md: 6 }}>
                    <WebsiteInput
                      setDepartmentInfoEntity={setDepartmentInfoEntity}
                      webURL={departmentInfoEntity.linkedin}
                      title="Linkedin"
                      attribute="linkedin"
                    />
                  </Grid>

                  <Grid size={{ xs: 12, md: 6 }}>
                    <WebsiteInput
                      setDepartmentInfoEntity={setDepartmentInfoEntity}
                      webURL={departmentInfoEntity.instagram}
                      title="Instagram"
                      attribute="instagram"
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={12} className="container container-buttons">
                <div className="save-button-container">
                  <Button
                    id="saveButton1"
                    onClick={sendDepartmentInfo}
                    disabled={disabledButton}
                    color="primary"
                    variant="contained"
                    style={{ maxWidth: '250px', minWidth: '250px', color: saveBtnTextColor }}
                  >
                    Save
                  </Button>
                  <Button
                    style={{ maxWidth: '250px', minWidth: '250px' }}
                    variant="outlined"
                    id="cancelButtonEntity"
                    color="primary"
                    onClick={openConfirmationDialog}
                    disabled={disabledButton}
                  >
                    Discard
                  </Button>
                  {renderSavedMessage()}
                </div>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}

export default ContactUs
